@let item1Image = data.items[0]!.image!;
@let item2Text = data.items[1]!.text!;
@let item3Image = data.items[2]!.image!;
@let item4Image = data.items[3]!.image!;
@let item5Video = data.items[4]?.video!;
@let item6Image = data.items[5]?.image!;

<div class="centered-with-padding mx-auto py-7">
  <div class="flex flex-col gap-y-5 desk:gap-y-4">
    @if (data.title; as title) {
      <app-title [title]="title" size="h2" />
    }

    @if (data.description; as description) {
      <span>{{ description }}</span>
    }
  </div>
  <div class="grid grid-cols-2 gap-1 pt-7 desk:grid-cols-3 desk:gap-4">
    <div
      class="group col-span-2 row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-1 desk:col-span-3 desk:row-span-full desk:h-[600px]">
      @if (item1Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item1Image)"
          [hoverEffect]="true"
          [image]="item1Image"
          [isPriority]="!isImageInPreviousBlocks"
          [pregenerationSize]="{ width: 1080, height: 600, exact: 'desk' }" />
      }
    </div>

    <div
      class="flex h-[calc(150px-.125rem)] flex-col justify-center gap-2 rounded-3xl bg-anis p-6 text-center desk:order-2 desk:aspect-square desk:h-auto desk:gap-9">
      @if (item2Text?.title; as title) {
        <app-title [title]="title" size="custom-15" />
      }
      @if (item2Text?.subtitle; as subtitle) {
        <span class="text-[10px] font-bold leading-[14px] desk:text-[14px] desk:leading-[19px]">{{ subtitle }}</span>
      }
    </div>

    <div
      class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-4 desk:row-span-1 desk:aspect-square desk:h-auto">
      @if (item3Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item3Image)"
          [hoverEffect]="true"
          [image]="item3Image"
          [pregenerationSize]="{ width: 349, height: 349, exact: 'desk' }" />
      }
    </div>

    <div class="group h-[calc(150px-.125rem)] overflow-hidden rounded-3xl desk:order-3 desk:aspect-square desk:h-auto">
      @if (item4Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item4Image)"
          [hoverEffect]="true"
          [image]="item4Image"
          [pregenerationSize]="{ width: 349, height: 349, exact: 'desk' }" />
      }
    </div>

    @if (!data.hideLastItem) {
      <div class="row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-5 desk:h-[500px]">
        @if (item5Video) {
          <app-video
            [autoplay]="true"
            [posterPregenerationSize]="{ width: 349, height: 500, exact: 'desk' }"
            [video]="item5Video" />
        }
      </div>

      <div
        class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-6 desk:col-span-2 desk:row-span-1 desk:h-[500px]">
        @if (item6Image) {
          <app-image
            class="cursor-zoom-in"
            (click)="zoomImageRequested.emit(item6Image)"
            [hoverEffect]="true"
            [image]="item6Image"
            [pregenerationSize]="{ width: 715, height: 500, exact: 'desk' }" />
        }
      </div>
    }
  </div>

  @if (data.cta; as cta) {
    <div class="my-5 text-center">
      <app-button [label]="cta.label" [url]="cta.url" />
    </div>
  }
</div>
